/**
 * @desc: 资料进件
 * @create：2020/4/10
 * @author: lijun
 * @version: v1.0
 */
import request from '@/plugins/http'
import qs from 'qs'

// 列表
export const getEntryList = params => {
  return request.get('/merchant/entry/list', params)
}

// 获取额度授信账户
export const getQueryCardList = params => {
  return request.get('/merchant/card/queryCardList', params)
}

// 获取该商户聚合支付信息
export const getUnionPayment = params => {
  return request.get('/merchant/card/queryUnionPayment', params)
}

// 业务发行/添加商户
export const saveNewMerchant = data => {
  return request.post('/merchant/entry/save', qs.stringify(data))
}

// 生成档案号
export const createdFileNum = params => {
  return request.get('/merchant/entry/getFileNum', params)
}

// 修改商户信息
export const updateMerchant = data => {
  return request.post('/merchant/entry/update', qs.stringify(data))
}
